<template>
  <PageTemplate :loading="loading">
    <v-container v-if="!loading" class="pt-10 pb-12">
      <v-row justify="center" v-if="item.title">
        <v-col cols="12" lg="8">
          <div
            class="
              secondary--text
              text--darken-1 text-h5 text-sm-h4 text-md-h3 text-lg-h2
              font-weight-bold
            "
          >
            {{ item.title }}
          </div>

          <div v-if="item.date" class="text-caption font-weight-light mt-4">
            {{ formatDate(item.date) }}
          </div>

          <img
            :src="files + item.img.featured.path + '?resize=1&w=800'"
            :alt="item.title"
            v-if="item.img && item.img.featured && item.img.featured.path"
            class="mt-8 d-block"
            width="100%"
          />

          <div
            class="secondary--text text--lighten-1 text-body-2 mt-10"
            v-if="item.text"
          >
            <span class="font--secondary" v-html="item.text"></span>
          </div>

          <Gallery v-if="images.length > 1" :images="images" class="mt-8" />
        </v-col>

        <v-col class="mt-10 mt-lg-0" cols="12" lg="4">
          <LatestArticles :item-id="parseFloat(itemId)" />
        </v-col>
      </v-row>
      <v-alert v-else type="info" class="mt-10">
        Nenhum item adicionado até o momento.
      </v-alert>
    </v-container>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../../templates/Page.vue";
import Gallery from "../../templates/Gallery.vue";
import LatestArticles from "../../widgets/LatestArticles.vue";

const _config = {
  mod: "articles",
};

export default {
  data: () => ({
    loading: true,
    item: {},
  }),
  computed: {
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
  },
  methods: {
    formatDate(date) {
      return new Intl.DateTimeFormat("pt-BR", { dateStyle: "long" }).format(
        new Date(date.replace(" ", "T"))
      );
    },
    get() {
      this.loading = true;

      this.$rest(_config.mod)
        .get({ id: this.itemId })
        .then((data) => {
          this.item = data;

          this.images = data.img.list.map(({ path }) => {
            return path ? this.files + path : "";
          });

          this.loading = false;
        })
        .catch(() => this.$router.replace("/error404"));
    },
  },
  watch: {
    itemId() {
      this.get();
    },
  },
  created() {
    this.get();

    fetch(`${this.server}/rest/articles/${this.itemId}/view`);
  },
  components: {
    PageTemplate,
    LatestArticles,
    Gallery,
  },
};
</script>
